export default __webpack_public_path__ + "static/media/image-graphic-design.7ac8bdf0.jpg";